import { AxiosPost, AxiosGet } from "../../helpers/microserviceAPIs"
import { documentSigningApiUrl } from "../../config/microservicesUrls"

const api_url = documentSigningApiUrl()

export async function docSigningApiListTemplatesPost(jwt, body) {
  return await AxiosPost(jwt, `${api_url}/api/Templates/List`, body)
}

export async function docSigningApiCreateTemplatePost(jwt, body) {
  return await AxiosPost(jwt, `${api_url}/api/Templates/Create`, body)
}

export async function docSigningApiUpdateTemplateOrganizationsPost(
  jwt,
  body,
  templateId
) {
  return await AxiosPost(
    jwt,
    `${api_url}/api/Templates/EditGroupAllocation/${templateId}`,
    body
  )
}

export async function docSigningApiEditTemplateGet(jwt, templateId) {
  return await AxiosGet(jwt, `${api_url}/api/Templates/Edit/${templateId}`)
}

export async function docSigningApiDeleteTemplateGet(jwt, templateId) {
  return await AxiosGet(jwt, `${api_url}/api/Templates/Delete/${templateId}`)
}

export async function docSigningApiRequestSignaturePost(jwt, body, templateId) {
  return await AxiosPost(
    jwt,
    `${api_url}/api/Templates/Send/${templateId}`,
    body
  )
}

export async function docSigningApiHelloSignConfigGet(jwt) {
  return await AxiosGet(jwt, `${api_url}/api/Configuration/HelloSign`)
}

export async function docSigningApiTemplateGet(jwt, templateId) {
  return await AxiosGet(jwt, `${api_url}/api/Templates/${templateId}`)
}

export async function docSigningApiSignatureRequestsListPost(jwt, body) {
  return await AxiosPost(jwt, `${api_url}/api/SignatureRequests/List`, body)
}

export async function docSigningApiSignatureRequestsCancelGet(
  jwt,
  signatureRequestId
) {
  return await AxiosGet(
    jwt,
    `${api_url}/api/SignatureRequests/Cancel/${signatureRequestId}`
  )
}

export async function docSigningApiSignatureRequestsDownloadGet(
  jwt,
  signatureRequestId
) {
  return await AxiosGet(
    jwt,
    `${api_url}/api/SignatureRequests/Download/${signatureRequestId}`
  )
}

export async function docSigningApiSignURLGet(jwt, signatureRequestId) {
  return await AxiosGet(
    jwt,
    `${api_url}/api/SignatureRequests/Sign/${signatureRequestId}`
  )
}

export async function docSigningApiRequestGet(jwt, signatureRequestId) {
  return await AxiosGet(
    jwt,
    `${api_url}/api/SignatureRequests/${signatureRequestId}`
  )
}
